import { Injectable, Pipe } from '@angular/core';
import { DlistDto, DlistFieldDto, GetLookup_Response } from '../../models/ortak.dtos';
import { LookupModel } from '../../models/dx-data-table.model';
import { environment } from '../../services/app-settings.service';
import { OrtakService } from '../../services/ortak.service';
import { CURRENCY_FORMAT } from '../../constants';
import { PivotGridDataSourceField } from 'devexpress-dashboard/viewer-parts/viewer-items/pivot-grid-item/_pivot-grid-item-helper';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { DataCoreService } from '../../services/data-core.service';

@Injectable({
  providedIn: 'root',
})
export class GenPivotGridService {


  private lookupData:LookupModel[] = [];

  private CURRENCY_FORMAT = CURRENCY_FORMAT;

  private pivotFieldsMap: Map<string, PivotGridDataSourceField[]> = new Map<string, PivotGridDataSourceField[]>();


  constructor(private ortakService:OrtakService,private dataCoreService:DataCoreService) {}


  createCustomStore(pivotLoadUrl:string, entity:string,gridDataSource:any) {

      const loadUrl = pivotLoadUrl
        ? environment.dataService + pivotLoadUrl
        : environment.dataService + entity;
      const key = gridDataSource.store().key;
      const loadParamSelect = JSON.stringify(
        gridDataSource?._storeLoadOptions?.select
      );

      return createStore({
        key: key,
        loadUrl: loadUrl,
        loadParams: {
          select: loadParamSelect,
        },
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.contentType = 'application/json';

          // DevExtreme createStore istekleri HttpInterceptor'ı bypass eder,
          // bu yüzden token'ı burada merkezi helper ile ekliyoruz.
          this.dataCoreService.appendAuthHeader(ajaxOptions);

          if (method === 'update') {
            const recordId = ajaxOptions.data.key;
            ajaxOptions.data = ajaxOptions.data.values;
            ajaxOptions.url += `/${recordId}`;
          }

          if (method === 'delete') {
            ajaxOptions.url += `/${ajaxOptions.data.key}`;
          }

          if (method === 'insert') {
            ajaxOptions.data = ajaxOptions.data.values;
          }
        },
      });
    }



  setPivotFields(gridCtl: DlistDto) {
    const fields:any[] = [];
    this.lookupData = [];
     gridCtl.fields.map((field: DlistFieldDto) => {
      if (field?.pivotSummary) {
        field.pivotSummary.split(',').forEach((summary) => {
          fields.push({
            dataField: field?.dataField,
            caption: field?.caption + '(' +( summary == 'sum' ? 'Top.' : summary == 'count' ? '*' : summary == 'avg' ? 'Ort' : '') + ')',
            dataType: field?.dataType,
            area: field?.pivotArea == 'list' ? null : field?.pivotArea,
            format: field?.format == 'currency' ? this.CURRENCY_FORMAT : field?.dataType == 'number' ? '#,##0.##' : undefined,
            visible: field?.pivotArea == null ? false : true,
            sortOrder: field?.sortOrder,
            summaryType: summary,
          });
        }
        );

      } else if(field?.lookup) {
        fields.push({
          dataField: field?.dataField,
          caption: field?.caption,
          dataType: field?.dataType,
          area: field?.pivotArea == 'list' ? null : field?.pivotArea,
          format: field?.format == 'currency' ? this.CURRENCY_FORMAT : field?.dataType == 'number' ? '#,##0.##' : undefined,
          visible: field?.pivotArea == null ? false : true,
          sortOrder: field?.sortOrder,
          customizeText: (e:any) =>  this.getLookupData(e, field?.lookup) ,
        });
      }else{
        fields.push({
          dataField: field?.dataField,
          caption: field?.caption,
          dataType: field?.dataType,
          area: field?.pivotArea == 'list' ? null : field?.pivotArea,
          format: field?.format == 'currency' ? this.CURRENCY_FORMAT : field?.dataType == 'number' ? '#,##0.##' : undefined,
          visible: field?.pivotArea == null ? false : true,
          sortOrder: field?.sortOrder,
        });
      }
    });

    gridCtl.fields.forEach((field:DlistFieldDto) => {
      if(field?.lookup){
        this.ortakService.getLookup(field.lookup, 0, null, 0, 0).subscribe(x => {
          const lookupObj = new LookupModel();
          lookupObj.lookupAd = field.lookup;
          lookupObj.data = x.items;
          this.lookupData.push(lookupObj);
        })
      }
    })

    return fields;
  }


   getLookupData = (e: any,lookupType:string) => {

        const lookupObj = this.lookupData.find(x => x.lookupAd === lookupType);

        if (lookupObj) {
          var valueExpr = 'ozelkod';
          if(typeof e.value === 'number'){
            valueExpr = 'kod';
          }
            const lookupItem = lookupObj.data.find((item: any) => item[valueExpr] === e.value);
          if (lookupItem) {
            return lookupItem.aciklama;
          }
        }
        return e.value;


      }




      deletePivotFieldsMapByKey(dlistCode:string){
        if(this.pivotFieldsMap.has(dlistCode)){
        this.pivotFieldsMap.delete(dlistCode);
        }
      }

      getPivotFieldFromMap(key:string):PivotGridDataSourceField[]{
        if(this.pivotFieldsMap.has(key)){
          return this.pivotFieldsMap.get(key);
        }else{
          return null;
        }
      }

      setPivotFieldToMap(key:string, fields:PivotGridDataSourceField[]){
        this.pivotFieldsMap.set(key, fields);
      }

}
